import { CopilotRecapSourceEnum } from "~/utils/enums/copilot/workflow.enums";
import type {
  ICopilotAttendanceRecap,
  ICopilotRecap,
  ICopilotRecapCount,
} from "~/utils/interfaces/copilot-blocks-interfaces";

/**
 * Which recap this is. Read off `source` rather than off the shape: the two payloads share no
 * field, so a shape guess would make an empty attendance recap — every count at 0 — look like a
 * training import and paint nothing at all.
 */
export function isAttendanceRecap(recap: ICopilotRecap): recap is ICopilotAttendanceRecap {
  return (recap as ICopilotAttendanceRecap).source === CopilotRecapSourceEnum.ATTENDANCE;
}

/** A count the backend left out reads as 0 rather than dropping its line: the bucket was empty. */
function count(value: number | undefined | null): string {
  return String(Number.isFinite(value) ? value : 0);
}

/**
 * What the analysis found, one line per bucket of the proposal. Every line is always shown, zero
 * included: "0 nom non rattaché" is the reassuring half of the answer, and a line that disappears
 * when empty leaves the admin counting which ones are missing.
 *
 * The hours are deliberately named after what they are — the matched bucket, as read on the sheet.
 * They are not the attendance that will be written: the admin still rules on the unmatched lines
 * and on the booked collaborators who never signed, and confirming is what declares any of it.
 */
export function attendanceRecapCounts(recap: ICopilotAttendanceRecap): ICopilotRecapCount[] {
  return [
    { label: "Signatures rattachées à un participant", value: count(recap.matchedCount) },
    { label: "Noms lus non rattachés", value: count(recap.notFoundInSessionCount) },
    { label: "Inscrits sans signature", value: count(recap.notFoundInFileCount) },
    { label: "Heures lues sur les signatures rattachées", value: `${count(recap.totalAttendedHours)} h` },
  ];
}
